import { parsePhoneNumber as parsePhoneNumberBase } from "awesome-phonenumber";

const parsePhoneNumber = number =>
  parsePhoneNumberBase(number, { regionCode: "US" });

export const formatPhoneNumber = (number, formatType = "significant") => {
  let valid;
  const phoneNumberObj = parsePhoneNumber(number);
  if (phoneNumberObj.number && phoneNumberObj.number[formatType]) {
    number = phoneNumberObj.number[formatType];
    valid = phoneNumberObj.valid;
  }
  return { number, valid };
};
